import { render, staticRenderFns } from "./ChatIconSecondary.vue?vue&type=template&id=375e5f75&scoped=true"
import script from "./ChatIconSecondary.vue?vue&type=script&lang=js"
export * from "./ChatIconSecondary.vue?vue&type=script&lang=js"
import style0 from "./ChatIconSecondary.vue?vue&type=style&index=0&id=375e5f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e5f75",
  null
  
)

export default component.exports